import { createBrowserRouter } from "react-router-dom";
import Login from "./Login";
import { RouterProvider } from "react-router-dom";
import Dashboard from "./NewSurvey/Dashboard";
import PropertyViewDetails from "./PropertyViewDetails";
import SignIn from "./Signin";
import NotFound from "./NotFound";
import HtmlQrCodeScannerComponent from "../components/common/Html5QrcodeScannerComponent";
import BookingForm from "./BookingForm/BookingForm";
import LeadDashboard from "./LeadDashboard";

const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/client",
      element: <Login />,
    },
    {
      path: "/client/:clientName",
      element: <Login />,
    },
    {
      path: "/client/:clientName/booking",
      element: <BookingForm />,
    },
    {
      path: "/signin",
      element: <SignIn />,
    },
    {
      path: "/new-survey",
      element: <Dashboard />,
    },
    {
      path: "/scanDoor",
      element: <HtmlQrCodeScannerComponent />,
    },
    {
      path: "/Dashboard",
      element: <PropertyViewDetails />,
    },

    {
      path: "/leadDashboard",
      element: <LeadDashboard />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={appRouter} />
    </div>
  );
};
export default Body;
